import React from 'react';
import SureModalSC from './sure-modal.styled';
import { HeadingTwo, BodyText } from '../../../typography';
import { FormattedMessage, injectIntl } from 'react-intl';
import dlt from '../../../../utils/default-lang';
import Button from '../../../ui/button';

const SureModal = ({ values, onSubmit, onClose }) => {
  return (
    <SureModalSC>
      <div className="top-text-wrap">
        <HeadingTwo className="bold">
          <FormattedMessage
            id="onboarding_aml_form_modal_headline"
            defaultMessage={dlt['onboarding_aml_form_modal_headline']}
          />
        </HeadingTwo>
        <BodyText>
          <FormattedMessage
            id="onboarding_aml_form_modal_subtext"
            defaultMessage={dlt['onboarding_aml_form_modal_subtext']}
          />
        </BodyText>
      </div>

      <div className="answers-wrap">
        <ul>
          {values.final_consumer === false ? (
            <li>
              <FormattedMessage
                id="onboarding_aml_form_modal_final_consumer_label"
                defaultMessage={dlt['onboarding_aml_form_modal_final_consumer_label']}
              />
            </li>
          ) : null}

          {values.politically_exposed === false ? (
            <li>
              <FormattedMessage
                id="onboarding_aml_form_modal_politically_exposed_label"
                defaultMessage={dlt['onboarding_aml_form_modal_politically_exposed_label']}
              />
            </li>
          ) : null}

          {values.sanctioned === false ? (
            <li>
              <FormattedMessage
                id="onboarding_aml_form_modal_sanctioned_label"
                defaultMessage={dlt['onboarding_aml_form_modal_sanctioned_label']}
              />
            </li>
          ) : null}

          {values.own_interest === false ? (
            <li>
              <FormattedMessage
                id="onboarding_aml_form_modal_own_interest_label"
                defaultMessage={dlt['onboarding_aml_form_modal_own_interest_label']}
              />
            </li>
          ) : null}

          {values.the_purpose_is_to_enhance_funding === false ? (
            <li>
              <FormattedMessage
                id="onboarding_aml_form_modal_the_purpose_is_to_enhance_funding_label"
                defaultMessage={
                  dlt['onboarding_aml_form_modal_the_purpose_is_to_enhance_funding_label']
                }
              />
            </li>
          ) : null}
        </ul>
      </div>

      <div className="submit-wrap">
        <Button type="PRIMARY" size="BIG" onClick={() => onClose()}>
          <FormattedMessage
            id="onboarding_aml_form_modal_btn_2"
            defaultMessage={dlt['onboarding_aml_form_modal_btn_2']}
          />
        </Button>
        <Button type="OUTLINED" size="BIG" onClick={() => onSubmit()}>
          <FormattedMessage
            id="onboarding_aml_form_modal_btn_1"
            defaultMessage={dlt['onboarding_aml_form_modal_btn_1']}
          />
        </Button>
      </div>
    </SureModalSC>
  );
};

export default injectIntl(SureModal);
